import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Breakpoint,
} from "@mui/material";

export interface IConfirmationCommonDialog {
  open: boolean;
  handleClose: () => void;
  text?: React.ReactNode; // Changed type to React.ReactNode
  actions: JSX.Element[];
  title?: string;
  size?:Breakpoint;
}

const ConfirmationCommonDialog: React.FC<IConfirmationCommonDialog> = ({
  open,
  handleClose,
  text,
  actions,
  title,
  size
}) => {
  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth={size != undefined ? size : "sm"}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title ? title : "Confirmation"}
      </DialogTitle>
      <DialogContent>
          {text}
      </DialogContent>
      <DialogActions>
        {actions.map((action, index) =>
          React.cloneElement(action, {
            key: index,
            onClick: () => {
              action.props.onClick();
              handleClose();
            },
          })
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationCommonDialog;
